<template>
  <v-container class="gray pa-3 ma-0 fluid subtitle-1 text-justify">
    <h1 class="mt-4">Instalação do Compilador Go</h1>
    <br />
    <v-layout>
      <v-flex>
        <v-row>
          <v-col class="col-10 offset-1">
            <p>Como já sabemos, o Wails integra um programa em Go com código HTML/CSS/Javascript.</p>
            <p>Portanto, precisamos instalar também o compilador Go.</p>
            <p>
              Para tanto, basta navegarmos até
              <a
                target="_blank"
                href="http://https://golang.org/dl/"
              >seu site</a> e fazer o download de seu instalador.
            </p>
          </v-col>

          <v-col class="col-6 offset-3">
            <v-img src="@/assets/Go.jpg"></v-img>
          </v-col>

          <v-col class="mt-3 col-10 offset-1">
            <p>
              É importante deixarmos claro que, se pretendermos que nosso sistema execute tanto em sistemas de 32 quanto de 64 bits. faça o download
              do compilador Go de 32 bits. Prefira o pacote
              <i>.msi</i>, cuja instalação é mais fácil e completa.
            </p>
            <p>
              Se a nossa idéia é termos o nosso sistema apenas em 64 bits, aí faça o download da versão de 64 bits. Óbvio que neste caso a sua máquina deve
              ser de 64 bits também.
            </p>
            <p>Após o download, executar o instalador.</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="col-1 offset-9">
            <v-btn class="primary" to="/installvscode">Instalação do VS Code</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-btn fab dark large color="success" fixed right bottom @click="GoTop()">
      <v-icon dark>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Installgo",
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    GoTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
